import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import CortanaPickerPlugin from './plugin/CortanaPickerPlugin';
import { LazyModule } from 'owa-bundling';
import { PluginEventType } from 'roosterjs-editor-types';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CortanaCompose" */ './lazyIndex')
);

export let LazyCortanaPickerPluginClass = createLazyPlugin(
    lazyModule,
    m => m.CortanaPickerPlugin,
    'CortanaCompose',
    evt => {
        if (evt.eventType === PluginEventType.KeyPress) {
            return evt.rawEvent.key == '/';
        }
        return false;
    }
);

export type LazyCortanaPickerPlugin = LazyPlugin<CortanaPickerPlugin>;
